import React from 'react';
import { LayoutWithNav } from '../components/Layout';

function NotFound() {
  return (
    <LayoutWithNav>
      <h1>Page not found...</h1>
    </LayoutWithNav>
  );
}

export default NotFound;
